module.exports = __webpack_public_path__ + "static/media/Tablet-inbox-3.1988f6ca.jpg";